// @flow
/* eslint-env node */
import { createStore, applyMiddleware } from 'redux';
import type { Middleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import type { State, Action, Dispatch } from './types';
import { SET as CAR_SET, BATCH_SET as CAR_BATCH_SET } from './constants/carConstants';
import { SET as PLANE_SET, BATCH_SET as PLANE_BATCH_SET } from './constants/planeConstants';
import rootReducer from './reducers';
import apiMiddleware from './middlewares/api';
import type { Config as ApiConfig } from './middlewares/api';

const initialStoreState = {};

const threshold = 1000;
const lastAction = {};
const composeEnhancers = composeWithDevTools({
    name: `amms-${process.env.NODE_ENV === 'production' ? 'production' : 'development'}`,
    maxAge: 1000,
    trace: true,
    traceLimit: 30,
    predicate: (state, action) => {
        if([CAR_SET, CAR_BATCH_SET, PLANE_SET, PLANE_BATCH_SET].indexOf(action.type) !== -1) {
            const lastTime = lastAction[action.type];
            if(!lastTime || Date.now() - lastTime > threshold) {
                lastAction[action.type] = Date.now();
                return true;
            }
            else {
                return false;
            }
        }

        return true;
    }
});

export type Config = $ReadOnly<{
    api: ApiConfig
}>;

export default function(initialState: State = initialStoreState, customMiddlewares?: $ReadOnlyArray<Middleware<State, Action, Dispatch>>, config?: Config = {}) {
    config = {
        ...config,
        // api: {
        //     // apiRoot: environment.config.apiBaseURL,
        //     headers: {
        //         'accept': 'application/json',
        //         ...(config.api && config.api.headers || {})
        //     },
        //     ...config.api
        // }
    };



    const middlewares = [
        thunk,
        // apiAuthentication,
        apiMiddleware(config.api),
        // apiError(error => ErrorLogger.log(error)),
        // createSeducer(seducers)
    ];

    if(process.env.NODE_ENV !== 'production') {
        const userTiming = require('./middlewares/userTiming').default; // eslint-disable-line global-require
        middlewares.push(userTiming);
    }

    const enhancers = composeEnhancers(
        applyMiddleware(
            ...middlewares,
            ...customMiddlewares || []
        )
    );

    const store = createStore<State, Action, Dispatch>(
        rootReducer,
        initialState,
        enhancers
    );

    if(process.env.NODE_ENV !== 'production') { //eslint-disable-line no-undef
        // $FlowFixMe
        if(module.hot) {
            // Enable Webpack hot module replacement for reducers
            module.hot.accept('./reducers', () => {
                const nextRootReducer = require('./reducers').default; // eslint-disable-line global-require
                store.replaceReducer(nextRootReducer)
            })
        }
    }

    return store;
}
